import {
  AZURE_API_AUDIENCE,
  AZURE_API_SCOPE,
  AZURE_AUTHORITY,
  AZURE_CLIENT_ID,
  AZURE_KNOWN_AUTHORITIES,
} from '../../environment';

const azureApiScope = AZURE_API_SCOPE;

// Entra ID
const envAuthority = AZURE_AUTHORITY;
export const msalConfig = {
  auth: {
    authority:
      !!envAuthority && envAuthority !== ''
        ? envAuthority
        : 'https://login.microsoftonline.com/common',
    clientId: AZURE_CLIENT_ID,
    audience: AZURE_API_AUDIENCE,
    redirectUri: window.location.origin,
    knownAuthorities: [AZURE_KNOWN_AUTHORITIES],
  },
  cache: {
    cacheLocation: 'sessionStorage',
  },
  system: {
    allowRedirectInIframe: true,
  },
};

export const loginRequest = {
  scopes: [azureApiScope, 'user.read'],
};

export const tokenRequest = {
  scopes: [azureApiScope, 'user.read'],
};

// /Entra ID
